<div class="app-container">

    @if(alertService.showAlert()){
    <div class="container-alert">
        <cdc-alert [type]="alertService.type()" [title]="alertService.title()" [message]="alertService.message()"
            [autoClose]="true">
        </cdc-alert>
    </div>
    }
    @if(spinnerService.isSpinnerVisible()){
        <app-spinner></app-spinner>
    }
    <router-outlet />
</div>